import { FC } from 'react';
import './radio-button.scss';

type TRadioButtonProps = {
  name: string;
  title: string;
  value: string | null;
  radioValue?: string;
  onChange: (name: string | null) => void;
  // disabled?: boolean;
};

const RadioButton: FC<TRadioButtonProps> = ({ name, title, radioValue, onChange, value }) => {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className={`order-radio ${radioValue === value ? 'order-radio--checked' : ''}`}>
      <input
        checked={radioValue === value}
        value={value || ''}
        name={name}
        onChange={(e) => onChange(e.target.value || null)}
        type="radio"
      />
      <div className="order-radio__input">
        <div className="order-radio__input-circle" />
      </div>
      <div className="order-radio__text-wrap">
        <div className="order-radio__title">{title}</div>
      </div>
    </label>
  );
};

export default RadioButton;
